import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { UpdateFavoriteListTitleModalProps } from './type'

import { Dialog } from '@/components/ui'
import { useMyStore } from '@/hooks/features/store'

import { UpdateFavoriteListTitleForm } from './Form'

export const UpdateFavoriteListTitleModal = ({
  isOpen,
  favorite,
  onClickConfirm,
  onClickCancel,
}: UpdateFavoriteListTitleModalProps) => {
  const myStore = useMyStore({})
  const { t } = useTranslation()

  const isDepositStore = useMemo(() => {
    if (!myStore.data?.isDepositStore) {
      return false
    }
    // create
    if (!favorite) {
      return true
    }
    // update
    return favorite.isEditableByMe
  }, [myStore, favorite])

  const title = useMemo(
    () =>
      isDepositStore
        ? t('favorite.list.title_edit_share')
        : t('favorite.list.title_edit'),
    [isDepositStore, t]
  )

  return (
    <Dialog title={title} isOpen={isOpen}>
      <UpdateFavoriteListTitleForm
        favorite={favorite}
        isDepositStore={isDepositStore}
        onClickConfirm={onClickConfirm}
        onClickCancel={onClickCancel}
      />
    </Dialog>
  )
}
